const utils = {
    getCurrentPosition() {
        return new Promise((resolve, reject) => {
            // 瀏覽器定位檢測
            if (!navigator.geolocation) {
                reject(new Error("您的瀏覽器不支持定位功能"));
                return;
            }

            const success = (loc) => {
                const location = {
                    latitude: loc.coords.latitude, 
                    longitude: loc.coords.longitude, 
                    accuracy: loc.coords.accuracy, 
                };
                resolve(location);
            };

            const error = (err) => {
                var errorType = [
                    "請先打開瀏覽器位置資訊的權限！",
                    "獲取不到位置信息！",
                    "獲取位置信息超時！",
                ];
                reject(new Error(errorType[err.code - 1]));
            };


            // 獲取當前位置
            navigator.geolocation.getCurrentPosition(success, error,
                {
                    enableHighAccuracy: true, 
                    timeout: 5000,            
                    maximumAge: 0             
                }
            )
        });
    },
}

export default utils